'use client';

import React from 'react';

interface HealthBarProps {
  health: number; // 0–3
}

export default function HealthBar({ health }: HealthBarProps) {
  return (
    <div className="hud-glass rounded-xl px-2 py-2 flex flex-col items-center gap-1.5">
      <p
        className="text-[9px] font-medium tracking-widest uppercase"
        style={{ color: '#556677', fontFamily: 'DM Sans, sans-serif' }}
      >
        Life
      </p>
      <div className="flex flex-col gap-1">
        {[2, 1, 0].map(i => {
          const filled = i < health;
          return (
            <div
              key={`health-pip-${i}`}
              className="rounded-sm transition-all duration-200"
              style={{
                width: '14px',
                height: '14px',
                background: filled ? '#ff4d6d' : 'rgba(255,77,109,0.12)',
                boxShadow: filled ? '0 0 6px #ff4d6d' : 'none',
                border: `1px solid ${filled ? '#ff4d6d' : 'rgba(255,77,109,0.2)'}`,
                borderRadius: '3px',
              }}
            />
          );
        })}
      </div>
    </div>
  );
}